var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    style: {
      minWidth: 20,
      minHeight: 20
    },
    className: "css-0 e11k6mr30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M20.896 6.023 18.52 4.106A.417.417 0 0 0 18.252 4a.41.41 0 0 0-.273.11L9.336 15.469s-3.397-3.342-3.493-3.44c-.095-.097-.22-.26-.41-.26-.191 0-.278.137-.377.239-.074.08-1.286 1.38-1.883 2.027-.035.04-.056.061-.086.092A.443.443 0 0 0 3 14.38c0 .097.035.177.087.252l.12.115s6.03 5.922 6.13 6.024c.099.102.22.23.397.23.173 0 .316-.19.399-.274l10.78-14.163A.445.445 0 0 0 21 6.306a.462.462 0 0 0-.104-.283z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.ffd271f1b49c41dcaa3bac1e5230fe3a.svg";
export { ForwardRef as ReactComponent };